import React, {useState} from "react";
import {
  MarketingAuthStatusEnum,
  MedicinesRequests,
  MedicinesSearchModel,
  NonSubstitutedMedicinesEnum
} from "@/app/api/medicines";
import {useNavigate} from "react-router-dom";
import {route} from "@/app/routes/AppRoutes";

interface NotesState {
  hasError: string | null;
  hasLoading: boolean;

}

const useNotes = () => {
  const [state, setState] = useState<NotesState>({
    hasError: null,
    hasLoading: true
  });

  const updateState = (updates: Partial<NotesState>) => {
    setState((prevState) => ({
      ...prevState,
      ...updates,
    }));
  };

  return {
    state,
    updateState,
  };
};

export default useNotes;